import { openBlock as f, createElementBlock as d, renderSlot as c, normalizeProps as A, guardReactiveProps as ee, mergeProps as O, Fragment as j, createCommentVNode as le, createElementVNode as b, toDisplayString as x, renderList as N, resolveComponent as vt, createBlock as mt, withCtx as Z, normalizeClass as te, normalizeStyle as hr, createVNode as gr, createTextVNode as ye, resolveDynamicComponent as pr } from "vue";
const yr = {
  componentPrefix: "V",
  requestHandler() {
    return new Promise((e, t) => {
      e([]);
    });
  },
  itemProps: {},
  typeAdapters: {},
  stateManager: {
    set() {
    },
    get() {
    },
    init() {
    }
  }
};
var br = typeof global == "object" && global && global.Object === Object && global;
const _t = br;
var vr = typeof self == "object" && self && self.Object === Object && self, mr = _t || vr || Function("return this")();
const w = mr;
var _r = w.Symbol;
const M = _r;
var $t = Object.prototype, $r = $t.hasOwnProperty, Pr = $t.toString, Q = M ? M.toStringTag : void 0;
function Sr(e) {
  var t = $r.call(e, Q), r = e[Q];
  try {
    e[Q] = void 0;
    var s = !0;
  } catch {
  }
  var a = Pr.call(e);
  return s && (t ? e[Q] = r : delete e[Q]), a;
}
var Tr = Object.prototype, Ar = Tr.toString;
function xr(e) {
  return Ar.call(e);
}
var Or = "[object Null]", wr = "[object Undefined]", Ne = M ? M.toStringTag : void 0;
function Y(e) {
  return e == null ? e === void 0 ? wr : Or : Ne && Ne in Object(e) ? Sr(e) : xr(e);
}
function U(e) {
  return e != null && typeof e == "object";
}
var Cr = "[object Symbol]";
function Pt(e) {
  return typeof e == "symbol" || U(e) && Y(e) == Cr;
}
function jr(e, t) {
  for (var r = -1, s = e == null ? 0 : e.length, a = Array(s); ++r < s; )
    a[r] = t(e[r], r, e);
  return a;
}
var Mr = Array.isArray;
const K = Mr;
var Lr = 1 / 0, Ue = M ? M.prototype : void 0, Be = Ue ? Ue.toString : void 0;
function St(e) {
  if (typeof e == "string")
    return e;
  if (K(e))
    return jr(e, St) + "";
  if (Pt(e))
    return Be ? Be.call(e) : "";
  var t = e + "";
  return t == "0" && 1 / e == -Lr ? "-0" : t;
}
var Er = /\s/;
function Ir(e) {
  for (var t = e.length; t-- && Er.test(e.charAt(t)); )
    ;
  return t;
}
var Rr = /^\s+/;
function Dr(e) {
  return e && e.slice(0, Ir(e) + 1).replace(Rr, "");
}
function B(e) {
  var t = typeof e;
  return e != null && (t == "object" || t == "function");
}
var Fe = 0 / 0, Nr = /^[-+]0x[0-9a-f]+$/i, Ur = /^0b[01]+$/i, Br = /^0o[0-7]+$/i, Fr = parseInt;
function ke(e) {
  if (typeof e == "number")
    return e;
  if (Pt(e))
    return Fe;
  if (B(e)) {
    var t = typeof e.valueOf == "function" ? e.valueOf() : e;
    e = B(t) ? t + "" : t;
  }
  if (typeof e != "string")
    return e === 0 ? e : +e;
  e = Dr(e);
  var r = Ur.test(e);
  return r || Br.test(e) ? Fr(e.slice(2), r ? 2 : 8) : Nr.test(e) ? Fe : +e;
}
var kr = "[object AsyncFunction]", zr = "[object Function]", Hr = "[object GeneratorFunction]", Gr = "[object Proxy]";
function Tt(e) {
  if (!B(e))
    return !1;
  var t = Y(e);
  return t == zr || t == Hr || t == kr || t == Gr;
}
var qr = w["__core-js_shared__"];
const be = qr;
var ze = function() {
  var e = /[^.]+$/.exec(be && be.keys && be.keys.IE_PROTO || "");
  return e ? "Symbol(src)_1." + e : "";
}();
function Wr(e) {
  return !!ze && ze in e;
}
var Vr = Function.prototype, Zr = Vr.toString;
function H(e) {
  if (e != null) {
    try {
      return Zr.call(e);
    } catch {
    }
    try {
      return e + "";
    } catch {
    }
  }
  return "";
}
var Kr = /[\\^$.*+?()[\]{}|]/g, Jr = /^\[object .+?Constructor\]$/, Yr = Function.prototype, Xr = Object.prototype, Qr = Yr.toString, en = Xr.hasOwnProperty, tn = RegExp(
  "^" + Qr.call(en).replace(Kr, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$"
);
function rn(e) {
  if (!B(e) || Wr(e))
    return !1;
  var t = Tt(e) ? tn : Jr;
  return t.test(H(e));
}
function nn(e, t) {
  return e == null ? void 0 : e[t];
}
function G(e, t) {
  var r = nn(e, t);
  return rn(r) ? r : void 0;
}
var sn = G(w, "WeakMap");
const $e = sn;
var He = Object.create, an = function() {
  function e() {
  }
  return function(t) {
    if (!B(t))
      return {};
    if (He)
      return He(t);
    e.prototype = t;
    var r = new e();
    return e.prototype = void 0, r;
  };
}();
const on = an;
function un(e, t) {
  var r = -1, s = e.length;
  for (t || (t = Array(s)); ++r < s; )
    t[r] = e[r];
  return t;
}
var ln = function() {
  try {
    var e = G(Object, "defineProperty");
    return e({}, "", {}), e;
  } catch {
  }
}();
const Ge = ln;
function cn(e, t) {
  for (var r = -1, s = e == null ? 0 : e.length; ++r < s && t(e[r], r, e) !== !1; )
    ;
  return e;
}
var fn = 9007199254740991, dn = /^(?:0|[1-9]\d*)$/;
function hn(e, t) {
  var r = typeof e;
  return t = t ?? fn, !!t && (r == "number" || r != "symbol" && dn.test(e)) && e > -1 && e % 1 == 0 && e < t;
}
function At(e, t, r) {
  t == "__proto__" && Ge ? Ge(e, t, {
    configurable: !0,
    enumerable: !0,
    value: r,
    writable: !0
  }) : e[t] = r;
}
function we(e, t) {
  return e === t || e !== e && t !== t;
}
var gn = Object.prototype, pn = gn.hasOwnProperty;
function xt(e, t, r) {
  var s = e[t];
  (!(pn.call(e, t) && we(s, r)) || r === void 0 && !(t in e)) && At(e, t, r);
}
function he(e, t, r, s) {
  var a = !r;
  r || (r = {});
  for (var n = -1, i = t.length; ++n < i; ) {
    var o = t[n], l = s ? s(r[o], e[o], o, r, e) : void 0;
    l === void 0 && (l = e[o]), a ? At(r, o, l) : xt(r, o, l);
  }
  return r;
}
var yn = 9007199254740991;
function Ot(e) {
  return typeof e == "number" && e > -1 && e % 1 == 0 && e <= yn;
}
function wt(e) {
  return e != null && Ot(e.length) && !Tt(e);
}
var bn = Object.prototype;
function Ce(e) {
  var t = e && e.constructor, r = typeof t == "function" && t.prototype || bn;
  return e === r;
}
function vn(e, t) {
  for (var r = -1, s = Array(e); ++r < e; )
    s[r] = t(r);
  return s;
}
var mn = "[object Arguments]";
function qe(e) {
  return U(e) && Y(e) == mn;
}
var Ct = Object.prototype, _n = Ct.hasOwnProperty, $n = Ct.propertyIsEnumerable, Pn = qe(function() {
  return arguments;
}()) ? qe : function(e) {
  return U(e) && _n.call(e, "callee") && !$n.call(e, "callee");
};
const Sn = Pn;
function Tn() {
  return !1;
}
var jt = typeof exports == "object" && exports && !exports.nodeType && exports, We = jt && typeof module == "object" && module && !module.nodeType && module, An = We && We.exports === jt, Ve = An ? w.Buffer : void 0, xn = Ve ? Ve.isBuffer : void 0, On = xn || Tn;
const ce = On;
var wn = "[object Arguments]", Cn = "[object Array]", jn = "[object Boolean]", Mn = "[object Date]", Ln = "[object Error]", En = "[object Function]", In = "[object Map]", Rn = "[object Number]", Dn = "[object Object]", Nn = "[object RegExp]", Un = "[object Set]", Bn = "[object String]", Fn = "[object WeakMap]", kn = "[object ArrayBuffer]", zn = "[object DataView]", Hn = "[object Float32Array]", Gn = "[object Float64Array]", qn = "[object Int8Array]", Wn = "[object Int16Array]", Vn = "[object Int32Array]", Zn = "[object Uint8Array]", Kn = "[object Uint8ClampedArray]", Jn = "[object Uint16Array]", Yn = "[object Uint32Array]", p = {};
p[Hn] = p[Gn] = p[qn] = p[Wn] = p[Vn] = p[Zn] = p[Kn] = p[Jn] = p[Yn] = !0;
p[wn] = p[Cn] = p[kn] = p[jn] = p[zn] = p[Mn] = p[Ln] = p[En] = p[In] = p[Rn] = p[Dn] = p[Nn] = p[Un] = p[Bn] = p[Fn] = !1;
function Xn(e) {
  return U(e) && Ot(e.length) && !!p[Y(e)];
}
function je(e) {
  return function(t) {
    return e(t);
  };
}
var Mt = typeof exports == "object" && exports && !exports.nodeType && exports, re = Mt && typeof module == "object" && module && !module.nodeType && module, Qn = re && re.exports === Mt, ve = Qn && _t.process, es = function() {
  try {
    var e = re && re.require && re.require("util").types;
    return e || ve && ve.binding && ve.binding("util");
  } catch {
  }
}();
const J = es;
var Ze = J && J.isTypedArray, ts = Ze ? je(Ze) : Xn;
const Lt = ts;
var rs = Object.prototype, ns = rs.hasOwnProperty;
function Et(e, t) {
  var r = K(e), s = !r && Sn(e), a = !r && !s && ce(e), n = !r && !s && !a && Lt(e), i = r || s || a || n, o = i ? vn(e.length, String) : [], l = o.length;
  for (var u in e)
    (t || ns.call(e, u)) && !(i && // Safari 9 has enumerable `arguments.length` in strict mode.
    (u == "length" || // Node.js 0.10 has enumerable non-index properties on buffers.
    a && (u == "offset" || u == "parent") || // PhantomJS 2 has enumerable non-index properties on typed arrays.
    n && (u == "buffer" || u == "byteLength" || u == "byteOffset") || // Skip index properties.
    hn(u, l))) && o.push(u);
  return o;
}
function It(e, t) {
  return function(r) {
    return e(t(r));
  };
}
var ss = It(Object.keys, Object);
const as = ss;
var is = Object.prototype, os = is.hasOwnProperty;
function us(e) {
  if (!Ce(e))
    return as(e);
  var t = [];
  for (var r in Object(e))
    os.call(e, r) && r != "constructor" && t.push(r);
  return t;
}
function Me(e) {
  return wt(e) ? Et(e) : us(e);
}
function ls(e) {
  var t = [];
  if (e != null)
    for (var r in Object(e))
      t.push(r);
  return t;
}
var cs = Object.prototype, fs = cs.hasOwnProperty;
function ds(e) {
  if (!B(e))
    return ls(e);
  var t = Ce(e), r = [];
  for (var s in e)
    s == "constructor" && (t || !fs.call(e, s)) || r.push(s);
  return r;
}
function Le(e) {
  return wt(e) ? Et(e, !0) : ds(e);
}
var hs = G(Object, "create");
const ne = hs;
function gs() {
  this.__data__ = ne ? ne(null) : {}, this.size = 0;
}
function ps(e) {
  var t = this.has(e) && delete this.__data__[e];
  return this.size -= t ? 1 : 0, t;
}
var ys = "__lodash_hash_undefined__", bs = Object.prototype, vs = bs.hasOwnProperty;
function ms(e) {
  var t = this.__data__;
  if (ne) {
    var r = t[e];
    return r === ys ? void 0 : r;
  }
  return vs.call(t, e) ? t[e] : void 0;
}
var _s = Object.prototype, $s = _s.hasOwnProperty;
function Ps(e) {
  var t = this.__data__;
  return ne ? t[e] !== void 0 : $s.call(t, e);
}
var Ss = "__lodash_hash_undefined__";
function Ts(e, t) {
  var r = this.__data__;
  return this.size += this.has(e) ? 0 : 1, r[e] = ne && t === void 0 ? Ss : t, this;
}
function z(e) {
  var t = -1, r = e == null ? 0 : e.length;
  for (this.clear(); ++t < r; ) {
    var s = e[t];
    this.set(s[0], s[1]);
  }
}
z.prototype.clear = gs;
z.prototype.delete = ps;
z.prototype.get = ms;
z.prototype.has = Ps;
z.prototype.set = Ts;
function As() {
  this.__data__ = [], this.size = 0;
}
function ge(e, t) {
  for (var r = e.length; r--; )
    if (we(e[r][0], t))
      return r;
  return -1;
}
var xs = Array.prototype, Os = xs.splice;
function ws(e) {
  var t = this.__data__, r = ge(t, e);
  if (r < 0)
    return !1;
  var s = t.length - 1;
  return r == s ? t.pop() : Os.call(t, r, 1), --this.size, !0;
}
function Cs(e) {
  var t = this.__data__, r = ge(t, e);
  return r < 0 ? void 0 : t[r][1];
}
function js(e) {
  return ge(this.__data__, e) > -1;
}
function Ms(e, t) {
  var r = this.__data__, s = ge(r, e);
  return s < 0 ? (++this.size, r.push([e, t])) : r[s][1] = t, this;
}
function I(e) {
  var t = -1, r = e == null ? 0 : e.length;
  for (this.clear(); ++t < r; ) {
    var s = e[t];
    this.set(s[0], s[1]);
  }
}
I.prototype.clear = As;
I.prototype.delete = ws;
I.prototype.get = Cs;
I.prototype.has = js;
I.prototype.set = Ms;
var Ls = G(w, "Map");
const se = Ls;
function Es() {
  this.size = 0, this.__data__ = {
    hash: new z(),
    map: new (se || I)(),
    string: new z()
  };
}
function Is(e) {
  var t = typeof e;
  return t == "string" || t == "number" || t == "symbol" || t == "boolean" ? e !== "__proto__" : e === null;
}
function pe(e, t) {
  var r = e.__data__;
  return Is(t) ? r[typeof t == "string" ? "string" : "hash"] : r.map;
}
function Rs(e) {
  var t = pe(this, e).delete(e);
  return this.size -= t ? 1 : 0, t;
}
function Ds(e) {
  return pe(this, e).get(e);
}
function Ns(e) {
  return pe(this, e).has(e);
}
function Us(e, t) {
  var r = pe(this, e), s = r.size;
  return r.set(e, t), this.size += r.size == s ? 0 : 1, this;
}
function q(e) {
  var t = -1, r = e == null ? 0 : e.length;
  for (this.clear(); ++t < r; ) {
    var s = e[t];
    this.set(s[0], s[1]);
  }
}
q.prototype.clear = Es;
q.prototype.delete = Rs;
q.prototype.get = Ds;
q.prototype.has = Ns;
q.prototype.set = Us;
function Ee(e) {
  return e == null ? "" : St(e);
}
function Rt(e, t) {
  for (var r = -1, s = t.length, a = e.length; ++r < s; )
    e[a + r] = t[r];
  return e;
}
var Bs = It(Object.getPrototypeOf, Object);
const Dt = Bs;
function Fs(e, t, r) {
  var s = -1, a = e.length;
  t < 0 && (t = -t > a ? 0 : a + t), r = r > a ? a : r, r < 0 && (r += a), a = t > r ? 0 : r - t >>> 0, t >>>= 0;
  for (var n = Array(a); ++s < a; )
    n[s] = e[s + t];
  return n;
}
function ks(e, t, r) {
  var s = e.length;
  return r = r === void 0 ? s : r, !t && r >= s ? e : Fs(e, t, r);
}
var zs = "\\ud800-\\udfff", Hs = "\\u0300-\\u036f", Gs = "\\ufe20-\\ufe2f", qs = "\\u20d0-\\u20ff", Ws = Hs + Gs + qs, Vs = "\\ufe0e\\ufe0f", Zs = "\\u200d", Ks = RegExp("[" + Zs + zs + Ws + Vs + "]");
function Nt(e) {
  return Ks.test(e);
}
function Js(e) {
  return e.split("");
}
var Ut = "\\ud800-\\udfff", Ys = "\\u0300-\\u036f", Xs = "\\ufe20-\\ufe2f", Qs = "\\u20d0-\\u20ff", ea = Ys + Xs + Qs, ta = "\\ufe0e\\ufe0f", ra = "[" + Ut + "]", Pe = "[" + ea + "]", Se = "\\ud83c[\\udffb-\\udfff]", na = "(?:" + Pe + "|" + Se + ")", Bt = "[^" + Ut + "]", Ft = "(?:\\ud83c[\\udde6-\\uddff]){2}", kt = "[\\ud800-\\udbff][\\udc00-\\udfff]", sa = "\\u200d", zt = na + "?", Ht = "[" + ta + "]?", aa = "(?:" + sa + "(?:" + [Bt, Ft, kt].join("|") + ")" + Ht + zt + ")*", ia = Ht + zt + aa, oa = "(?:" + [Bt + Pe + "?", Pe, Ft, kt, ra].join("|") + ")", ua = RegExp(Se + "(?=" + Se + ")|" + oa + ia, "g");
function la(e) {
  return e.match(ua) || [];
}
function ca(e) {
  return Nt(e) ? la(e) : Js(e);
}
function fa(e) {
  return function(t) {
    t = Ee(t);
    var r = Nt(t) ? ca(t) : void 0, s = r ? r[0] : t.charAt(0), a = r ? ks(r, 1).join("") : t.slice(1);
    return s[e]() + a;
  };
}
var da = fa("toUpperCase");
const ha = da;
function ga(e, t, r, s) {
  var a = -1, n = e == null ? 0 : e.length;
  for (s && n && (r = e[++a]); ++a < n; )
    r = t(r, e[a], a, e);
  return r;
}
function pa(e) {
  return function(t) {
    return e == null ? void 0 : e[t];
  };
}
var ya = {
  // Latin-1 Supplement block.
  À: "A",
  Á: "A",
  Â: "A",
  Ã: "A",
  Ä: "A",
  Å: "A",
  à: "a",
  á: "a",
  â: "a",
  ã: "a",
  ä: "a",
  å: "a",
  Ç: "C",
  ç: "c",
  Ð: "D",
  ð: "d",
  È: "E",
  É: "E",
  Ê: "E",
  Ë: "E",
  è: "e",
  é: "e",
  ê: "e",
  ë: "e",
  Ì: "I",
  Í: "I",
  Î: "I",
  Ï: "I",
  ì: "i",
  í: "i",
  î: "i",
  ï: "i",
  Ñ: "N",
  ñ: "n",
  Ò: "O",
  Ó: "O",
  Ô: "O",
  Õ: "O",
  Ö: "O",
  Ø: "O",
  ò: "o",
  ó: "o",
  ô: "o",
  õ: "o",
  ö: "o",
  ø: "o",
  Ù: "U",
  Ú: "U",
  Û: "U",
  Ü: "U",
  ù: "u",
  ú: "u",
  û: "u",
  ü: "u",
  Ý: "Y",
  ý: "y",
  ÿ: "y",
  Æ: "Ae",
  æ: "ae",
  Þ: "Th",
  þ: "th",
  ß: "ss",
  // Latin Extended-A block.
  Ā: "A",
  Ă: "A",
  Ą: "A",
  ā: "a",
  ă: "a",
  ą: "a",
  Ć: "C",
  Ĉ: "C",
  Ċ: "C",
  Č: "C",
  ć: "c",
  ĉ: "c",
  ċ: "c",
  č: "c",
  Ď: "D",
  Đ: "D",
  ď: "d",
  đ: "d",
  Ē: "E",
  Ĕ: "E",
  Ė: "E",
  Ę: "E",
  Ě: "E",
  ē: "e",
  ĕ: "e",
  ė: "e",
  ę: "e",
  ě: "e",
  Ĝ: "G",
  Ğ: "G",
  Ġ: "G",
  Ģ: "G",
  ĝ: "g",
  ğ: "g",
  ġ: "g",
  ģ: "g",
  Ĥ: "H",
  Ħ: "H",
  ĥ: "h",
  ħ: "h",
  Ĩ: "I",
  Ī: "I",
  Ĭ: "I",
  Į: "I",
  İ: "I",
  ĩ: "i",
  ī: "i",
  ĭ: "i",
  į: "i",
  ı: "i",
  Ĵ: "J",
  ĵ: "j",
  Ķ: "K",
  ķ: "k",
  ĸ: "k",
  Ĺ: "L",
  Ļ: "L",
  Ľ: "L",
  Ŀ: "L",
  Ł: "L",
  ĺ: "l",
  ļ: "l",
  ľ: "l",
  ŀ: "l",
  ł: "l",
  Ń: "N",
  Ņ: "N",
  Ň: "N",
  Ŋ: "N",
  ń: "n",
  ņ: "n",
  ň: "n",
  ŋ: "n",
  Ō: "O",
  Ŏ: "O",
  Ő: "O",
  ō: "o",
  ŏ: "o",
  ő: "o",
  Ŕ: "R",
  Ŗ: "R",
  Ř: "R",
  ŕ: "r",
  ŗ: "r",
  ř: "r",
  Ś: "S",
  Ŝ: "S",
  Ş: "S",
  Š: "S",
  ś: "s",
  ŝ: "s",
  ş: "s",
  š: "s",
  Ţ: "T",
  Ť: "T",
  Ŧ: "T",
  ţ: "t",
  ť: "t",
  ŧ: "t",
  Ũ: "U",
  Ū: "U",
  Ŭ: "U",
  Ů: "U",
  Ű: "U",
  Ų: "U",
  ũ: "u",
  ū: "u",
  ŭ: "u",
  ů: "u",
  ű: "u",
  ų: "u",
  Ŵ: "W",
  ŵ: "w",
  Ŷ: "Y",
  ŷ: "y",
  Ÿ: "Y",
  Ź: "Z",
  Ż: "Z",
  Ž: "Z",
  ź: "z",
  ż: "z",
  ž: "z",
  Ĳ: "IJ",
  ĳ: "ij",
  Œ: "Oe",
  œ: "oe",
  ŉ: "'n",
  ſ: "s"
}, ba = pa(ya);
const va = ba;
var ma = /[\xc0-\xd6\xd8-\xf6\xf8-\xff\u0100-\u017f]/g, _a = "\\u0300-\\u036f", $a = "\\ufe20-\\ufe2f", Pa = "\\u20d0-\\u20ff", Sa = _a + $a + Pa, Ta = "[" + Sa + "]", Aa = RegExp(Ta, "g");
function xa(e) {
  return e = Ee(e), e && e.replace(ma, va).replace(Aa, "");
}
var Oa = /[^\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\x7f]+/g;
function wa(e) {
  return e.match(Oa) || [];
}
var Ca = /[a-z][A-Z]|[A-Z]{2}[a-z]|[0-9][a-zA-Z]|[a-zA-Z][0-9]|[^a-zA-Z0-9 ]/;
function ja(e) {
  return Ca.test(e);
}
var Gt = "\\ud800-\\udfff", Ma = "\\u0300-\\u036f", La = "\\ufe20-\\ufe2f", Ea = "\\u20d0-\\u20ff", Ia = Ma + La + Ea, qt = "\\u2700-\\u27bf", Wt = "a-z\\xdf-\\xf6\\xf8-\\xff", Ra = "\\xac\\xb1\\xd7\\xf7", Da = "\\x00-\\x2f\\x3a-\\x40\\x5b-\\x60\\x7b-\\xbf", Na = "\\u2000-\\u206f", Ua = " \\t\\x0b\\f\\xa0\\ufeff\\n\\r\\u2028\\u2029\\u1680\\u180e\\u2000\\u2001\\u2002\\u2003\\u2004\\u2005\\u2006\\u2007\\u2008\\u2009\\u200a\\u202f\\u205f\\u3000", Vt = "A-Z\\xc0-\\xd6\\xd8-\\xde", Ba = "\\ufe0e\\ufe0f", Zt = Ra + Da + Na + Ua, Kt = "['’]", Ke = "[" + Zt + "]", Fa = "[" + Ia + "]", Jt = "\\d+", ka = "[" + qt + "]", Yt = "[" + Wt + "]", Xt = "[^" + Gt + Zt + Jt + qt + Wt + Vt + "]", za = "\\ud83c[\\udffb-\\udfff]", Ha = "(?:" + Fa + "|" + za + ")", Ga = "[^" + Gt + "]", Qt = "(?:\\ud83c[\\udde6-\\uddff]){2}", er = "[\\ud800-\\udbff][\\udc00-\\udfff]", V = "[" + Vt + "]", qa = "\\u200d", Je = "(?:" + Yt + "|" + Xt + ")", Wa = "(?:" + V + "|" + Xt + ")", Ye = "(?:" + Kt + "(?:d|ll|m|re|s|t|ve))?", Xe = "(?:" + Kt + "(?:D|LL|M|RE|S|T|VE))?", tr = Ha + "?", rr = "[" + Ba + "]?", Va = "(?:" + qa + "(?:" + [Ga, Qt, er].join("|") + ")" + rr + tr + ")*", Za = "\\d*(?:1st|2nd|3rd|(?![123])\\dth)(?=\\b|[A-Z_])", Ka = "\\d*(?:1ST|2ND|3RD|(?![123])\\dTH)(?=\\b|[a-z_])", Ja = rr + tr + Va, Ya = "(?:" + [ka, Qt, er].join("|") + ")" + Ja, Xa = RegExp([
  V + "?" + Yt + "+" + Ye + "(?=" + [Ke, V, "$"].join("|") + ")",
  Wa + "+" + Xe + "(?=" + [Ke, V + Je, "$"].join("|") + ")",
  V + "?" + Je + "+" + Ye,
  V + "+" + Xe,
  Ka,
  Za,
  Jt,
  Ya
].join("|"), "g");
function Qa(e) {
  return e.match(Xa) || [];
}
function ei(e, t, r) {
  return e = Ee(e), t = r ? void 0 : t, t === void 0 ? ja(e) ? Qa(e) : wa(e) : e.match(t) || [];
}
var ti = "['’]", ri = RegExp(ti, "g");
function ni(e) {
  return function(t) {
    return ga(ei(xa(t).replace(ri, "")), e, "");
  };
}
function si() {
  this.__data__ = new I(), this.size = 0;
}
function ai(e) {
  var t = this.__data__, r = t.delete(e);
  return this.size = t.size, r;
}
function ii(e) {
  return this.__data__.get(e);
}
function oi(e) {
  return this.__data__.has(e);
}
var ui = 200;
function li(e, t) {
  var r = this.__data__;
  if (r instanceof I) {
    var s = r.__data__;
    if (!se || s.length < ui - 1)
      return s.push([e, t]), this.size = ++r.size, this;
    r = this.__data__ = new q(s);
  }
  return r.set(e, t), this.size = r.size, this;
}
function E(e) {
  var t = this.__data__ = new I(e);
  this.size = t.size;
}
E.prototype.clear = si;
E.prototype.delete = ai;
E.prototype.get = ii;
E.prototype.has = oi;
E.prototype.set = li;
function ci(e, t) {
  return e && he(t, Me(t), e);
}
function fi(e, t) {
  return e && he(t, Le(t), e);
}
var nr = typeof exports == "object" && exports && !exports.nodeType && exports, Qe = nr && typeof module == "object" && module && !module.nodeType && module, di = Qe && Qe.exports === nr, et = di ? w.Buffer : void 0, tt = et ? et.allocUnsafe : void 0;
function hi(e, t) {
  if (t)
    return e.slice();
  var r = e.length, s = tt ? tt(r) : new e.constructor(r);
  return e.copy(s), s;
}
function gi(e, t) {
  for (var r = -1, s = e == null ? 0 : e.length, a = 0, n = []; ++r < s; ) {
    var i = e[r];
    t(i, r, e) && (n[a++] = i);
  }
  return n;
}
function sr() {
  return [];
}
var pi = Object.prototype, yi = pi.propertyIsEnumerable, rt = Object.getOwnPropertySymbols, bi = rt ? function(e) {
  return e == null ? [] : (e = Object(e), gi(rt(e), function(t) {
    return yi.call(e, t);
  }));
} : sr;
const Ie = bi;
function vi(e, t) {
  return he(e, Ie(e), t);
}
var mi = Object.getOwnPropertySymbols, _i = mi ? function(e) {
  for (var t = []; e; )
    Rt(t, Ie(e)), e = Dt(e);
  return t;
} : sr;
const ar = _i;
function $i(e, t) {
  return he(e, ar(e), t);
}
function ir(e, t, r) {
  var s = t(e);
  return K(e) ? s : Rt(s, r(e));
}
function Te(e) {
  return ir(e, Me, Ie);
}
function Pi(e) {
  return ir(e, Le, ar);
}
var Si = G(w, "DataView");
const Ae = Si;
var Ti = G(w, "Promise");
const xe = Ti;
var Ai = G(w, "Set");
const Oe = Ai;
var nt = "[object Map]", xi = "[object Object]", st = "[object Promise]", at = "[object Set]", it = "[object WeakMap]", ot = "[object DataView]", Oi = H(Ae), wi = H(se), Ci = H(xe), ji = H(Oe), Mi = H($e), k = Y;
(Ae && k(new Ae(new ArrayBuffer(1))) != ot || se && k(new se()) != nt || xe && k(xe.resolve()) != st || Oe && k(new Oe()) != at || $e && k(new $e()) != it) && (k = function(e) {
  var t = Y(e), r = t == xi ? e.constructor : void 0, s = r ? H(r) : "";
  if (s)
    switch (s) {
      case Oi:
        return ot;
      case wi:
        return nt;
      case Ci:
        return st;
      case ji:
        return at;
      case Mi:
        return it;
    }
  return t;
});
const ae = k;
var Li = Object.prototype, Ei = Li.hasOwnProperty;
function Ii(e) {
  var t = e.length, r = new e.constructor(t);
  return t && typeof e[0] == "string" && Ei.call(e, "index") && (r.index = e.index, r.input = e.input), r;
}
var Ri = w.Uint8Array;
const fe = Ri;
function Re(e) {
  var t = new e.constructor(e.byteLength);
  return new fe(t).set(new fe(e)), t;
}
function Di(e, t) {
  var r = t ? Re(e.buffer) : e.buffer;
  return new e.constructor(r, e.byteOffset, e.byteLength);
}
var Ni = /\w*$/;
function Ui(e) {
  var t = new e.constructor(e.source, Ni.exec(e));
  return t.lastIndex = e.lastIndex, t;
}
var ut = M ? M.prototype : void 0, lt = ut ? ut.valueOf : void 0;
function Bi(e) {
  return lt ? Object(lt.call(e)) : {};
}
function Fi(e, t) {
  var r = t ? Re(e.buffer) : e.buffer;
  return new e.constructor(r, e.byteOffset, e.length);
}
var ki = "[object Boolean]", zi = "[object Date]", Hi = "[object Map]", Gi = "[object Number]", qi = "[object RegExp]", Wi = "[object Set]", Vi = "[object String]", Zi = "[object Symbol]", Ki = "[object ArrayBuffer]", Ji = "[object DataView]", Yi = "[object Float32Array]", Xi = "[object Float64Array]", Qi = "[object Int8Array]", eo = "[object Int16Array]", to = "[object Int32Array]", ro = "[object Uint8Array]", no = "[object Uint8ClampedArray]", so = "[object Uint16Array]", ao = "[object Uint32Array]";
function io(e, t, r) {
  var s = e.constructor;
  switch (t) {
    case Ki:
      return Re(e);
    case ki:
    case zi:
      return new s(+e);
    case Ji:
      return Di(e, r);
    case Yi:
    case Xi:
    case Qi:
    case eo:
    case to:
    case ro:
    case no:
    case so:
    case ao:
      return Fi(e, r);
    case Hi:
      return new s();
    case Gi:
    case Vi:
      return new s(e);
    case qi:
      return Ui(e);
    case Wi:
      return new s();
    case Zi:
      return Bi(e);
  }
}
function oo(e) {
  return typeof e.constructor == "function" && !Ce(e) ? on(Dt(e)) : {};
}
var uo = "[object Map]";
function lo(e) {
  return U(e) && ae(e) == uo;
}
var ct = J && J.isMap, co = ct ? je(ct) : lo;
const fo = co;
var ho = "[object Set]";
function go(e) {
  return U(e) && ae(e) == ho;
}
var ft = J && J.isSet, po = ft ? je(ft) : go;
const yo = po;
var bo = 1, vo = 2, mo = 4, or = "[object Arguments]", _o = "[object Array]", $o = "[object Boolean]", Po = "[object Date]", So = "[object Error]", ur = "[object Function]", To = "[object GeneratorFunction]", Ao = "[object Map]", xo = "[object Number]", lr = "[object Object]", Oo = "[object RegExp]", wo = "[object Set]", Co = "[object String]", jo = "[object Symbol]", Mo = "[object WeakMap]", Lo = "[object ArrayBuffer]", Eo = "[object DataView]", Io = "[object Float32Array]", Ro = "[object Float64Array]", Do = "[object Int8Array]", No = "[object Int16Array]", Uo = "[object Int32Array]", Bo = "[object Uint8Array]", Fo = "[object Uint8ClampedArray]", ko = "[object Uint16Array]", zo = "[object Uint32Array]", g = {};
g[or] = g[_o] = g[Lo] = g[Eo] = g[$o] = g[Po] = g[Io] = g[Ro] = g[Do] = g[No] = g[Uo] = g[Ao] = g[xo] = g[lr] = g[Oo] = g[wo] = g[Co] = g[jo] = g[Bo] = g[Fo] = g[ko] = g[zo] = !0;
g[So] = g[ur] = g[Mo] = !1;
function ue(e, t, r, s, a, n) {
  var i, o = t & bo, l = t & vo, u = t & mo;
  if (r && (i = a ? r(e, s, a, n) : r(e)), i !== void 0)
    return i;
  if (!B(e))
    return e;
  var v = K(e);
  if (v) {
    if (i = Ii(e), !o)
      return un(e, i);
  } else {
    var h = ae(e), y = h == ur || h == To;
    if (ce(e))
      return hi(e, o);
    if (h == lr || h == or || y && !a) {
      if (i = l || y ? {} : oo(e), !o)
        return l ? $i(e, fi(i, e)) : vi(e, ci(i, e));
    } else {
      if (!g[h])
        return a ? e : {};
      i = io(e, h, o);
    }
  }
  n || (n = new E());
  var P = n.get(e);
  if (P)
    return P;
  n.set(e, i), yo(e) ? e.forEach(function(m) {
    i.add(ue(m, t, r, m, e, n));
  }) : fo(e) && e.forEach(function(m, _) {
    i.set(_, ue(m, t, r, _, e, n));
  });
  var S = u ? l ? Pi : Te : l ? Le : Me, T = v ? void 0 : S(e);
  return cn(T || e, function(m, _) {
    T && (_ = m, m = e[_]), xt(i, _, ue(m, t, r, _, e, n));
  }), i;
}
var Ho = 1, Go = 4;
function qo(e) {
  return ue(e, Ho | Go);
}
var Wo = "__lodash_hash_undefined__";
function Vo(e) {
  return this.__data__.set(e, Wo), this;
}
function Zo(e) {
  return this.__data__.has(e);
}
function de(e) {
  var t = -1, r = e == null ? 0 : e.length;
  for (this.__data__ = new q(); ++t < r; )
    this.add(e[t]);
}
de.prototype.add = de.prototype.push = Vo;
de.prototype.has = Zo;
function Ko(e, t) {
  for (var r = -1, s = e == null ? 0 : e.length; ++r < s; )
    if (t(e[r], r, e))
      return !0;
  return !1;
}
function Jo(e, t) {
  return e.has(t);
}
var Yo = 1, Xo = 2;
function cr(e, t, r, s, a, n) {
  var i = r & Yo, o = e.length, l = t.length;
  if (o != l && !(i && l > o))
    return !1;
  var u = n.get(e), v = n.get(t);
  if (u && v)
    return u == t && v == e;
  var h = -1, y = !0, P = r & Xo ? new de() : void 0;
  for (n.set(e, t), n.set(t, e); ++h < o; ) {
    var S = e[h], T = t[h];
    if (s)
      var m = i ? s(T, S, h, t, e, n) : s(S, T, h, e, t, n);
    if (m !== void 0) {
      if (m)
        continue;
      y = !1;
      break;
    }
    if (P) {
      if (!Ko(t, function(_, C) {
        if (!Jo(P, C) && (S === _ || a(S, _, r, s, n)))
          return P.push(C);
      })) {
        y = !1;
        break;
      }
    } else if (!(S === T || a(S, T, r, s, n))) {
      y = !1;
      break;
    }
  }
  return n.delete(e), n.delete(t), y;
}
function Qo(e) {
  var t = -1, r = Array(e.size);
  return e.forEach(function(s, a) {
    r[++t] = [a, s];
  }), r;
}
function eu(e) {
  var t = -1, r = Array(e.size);
  return e.forEach(function(s) {
    r[++t] = s;
  }), r;
}
var tu = 1, ru = 2, nu = "[object Boolean]", su = "[object Date]", au = "[object Error]", iu = "[object Map]", ou = "[object Number]", uu = "[object RegExp]", lu = "[object Set]", cu = "[object String]", fu = "[object Symbol]", du = "[object ArrayBuffer]", hu = "[object DataView]", dt = M ? M.prototype : void 0, me = dt ? dt.valueOf : void 0;
function gu(e, t, r, s, a, n, i) {
  switch (r) {
    case hu:
      if (e.byteLength != t.byteLength || e.byteOffset != t.byteOffset)
        return !1;
      e = e.buffer, t = t.buffer;
    case du:
      return !(e.byteLength != t.byteLength || !n(new fe(e), new fe(t)));
    case nu:
    case su:
    case ou:
      return we(+e, +t);
    case au:
      return e.name == t.name && e.message == t.message;
    case uu:
    case cu:
      return e == t + "";
    case iu:
      var o = Qo;
    case lu:
      var l = s & tu;
      if (o || (o = eu), e.size != t.size && !l)
        return !1;
      var u = i.get(e);
      if (u)
        return u == t;
      s |= ru, i.set(e, t);
      var v = cr(o(e), o(t), s, a, n, i);
      return i.delete(e), v;
    case fu:
      if (me)
        return me.call(e) == me.call(t);
  }
  return !1;
}
var pu = 1, yu = Object.prototype, bu = yu.hasOwnProperty;
function vu(e, t, r, s, a, n) {
  var i = r & pu, o = Te(e), l = o.length, u = Te(t), v = u.length;
  if (l != v && !i)
    return !1;
  for (var h = l; h--; ) {
    var y = o[h];
    if (!(i ? y in t : bu.call(t, y)))
      return !1;
  }
  var P = n.get(e), S = n.get(t);
  if (P && S)
    return P == t && S == e;
  var T = !0;
  n.set(e, t), n.set(t, e);
  for (var m = i; ++h < l; ) {
    y = o[h];
    var _ = e[y], C = t[y];
    if (s)
      var ie = i ? s(C, _, y, t, e, n) : s(_, C, y, e, t, n);
    if (!(ie === void 0 ? _ === C || a(_, C, r, s, n) : ie)) {
      T = !1;
      break;
    }
    m || (m = y == "constructor");
  }
  if (T && !m) {
    var W = e.constructor, R = t.constructor;
    W != R && "constructor" in e && "constructor" in t && !(typeof W == "function" && W instanceof W && typeof R == "function" && R instanceof R) && (T = !1);
  }
  return n.delete(e), n.delete(t), T;
}
var mu = 1, ht = "[object Arguments]", gt = "[object Array]", oe = "[object Object]", _u = Object.prototype, pt = _u.hasOwnProperty;
function $u(e, t, r, s, a, n) {
  var i = K(e), o = K(t), l = i ? gt : ae(e), u = o ? gt : ae(t);
  l = l == ht ? oe : l, u = u == ht ? oe : u;
  var v = l == oe, h = u == oe, y = l == u;
  if (y && ce(e)) {
    if (!ce(t))
      return !1;
    i = !0, v = !1;
  }
  if (y && !v)
    return n || (n = new E()), i || Lt(e) ? cr(e, t, r, s, a, n) : gu(e, t, l, r, s, a, n);
  if (!(r & mu)) {
    var P = v && pt.call(e, "__wrapped__"), S = h && pt.call(t, "__wrapped__");
    if (P || S) {
      var T = P ? e.value() : e, m = S ? t.value() : t;
      return n || (n = new E()), a(T, m, r, s, n);
    }
  }
  return y ? (n || (n = new E()), vu(e, t, r, s, a, n)) : !1;
}
function fr(e, t, r, s, a) {
  return e === t ? !0 : e == null || t == null || !U(e) && !U(t) ? e !== e && t !== t : $u(e, t, r, s, fr, a);
}
var Pu = function() {
  return w.Date.now();
};
const _e = Pu;
var Su = "Expected a function", Tu = Math.max, Au = Math.min;
function yt(e, t, r) {
  var s, a, n, i, o, l, u = 0, v = !1, h = !1, y = !0;
  if (typeof e != "function")
    throw new TypeError(Su);
  t = ke(t) || 0, B(r) && (v = !!r.leading, h = "maxWait" in r, n = h ? Tu(ke(r.maxWait) || 0, t) : n, y = "trailing" in r ? !!r.trailing : y);
  function P($) {
    var D = s, X = a;
    return s = a = void 0, u = $, i = e.apply(X, D), i;
  }
  function S($) {
    return u = $, o = setTimeout(_, t), v ? P($) : i;
  }
  function T($) {
    var D = $ - l, X = $ - u, De = t - D;
    return h ? Au(De, n - X) : De;
  }
  function m($) {
    var D = $ - l, X = $ - u;
    return l === void 0 || D >= t || D < 0 || h && X >= n;
  }
  function _() {
    var $ = _e();
    if (m($))
      return C($);
    o = setTimeout(_, T($));
  }
  function C($) {
    return o = void 0, y && s ? P($) : (s = a = void 0, i);
  }
  function ie() {
    o !== void 0 && clearTimeout(o), u = 0, s = l = a = o = void 0;
  }
  function W() {
    return o === void 0 ? i : C(_e());
  }
  function R() {
    var $ = _e(), D = m($);
    if (s = arguments, a = this, l = $, D) {
      if (o === void 0)
        return S(l);
      if (h)
        return clearTimeout(o), o = setTimeout(_, t), P(l);
    }
    return o === void 0 && (o = setTimeout(_, t)), i;
  }
  return R.cancel = ie, R.flush = W, R;
}
function xu(e, t) {
  return fr(e, t);
}
var Ou = ni(function(e, t, r) {
  return e + (r ? " " : "") + ha(t);
});
const bt = Ou, L = (e, t) => {
  const r = e.__vccOpts || e;
  for (const [s, a] of t)
    r[s] = a;
  return r;
}, wu = {
  name: "VList",
  props: {
    /**
     * An API endpoint to hit for getting data.
     */
    endpoint: String,
    /**
     * Static Config which will be passed to handler
     */
    config: Object,
    /**
     * Default page to load.
     * The prop is just an initial value.
     * Local state is managed by localPage.
     */
    page: {
      type: Number,
      default: 1
    },
    /**
     * Number of results to fetch and display on each page.
     * The prop is just an initial value.
     * Local state is managed by localPerPage.
     */
    perPage: {
      type: Number,
      default: 25
    },
    /**
     * DO WE NEED THIS?
     * Additional parameters to pass when making an API request.
     * This prop does not have any local copy as it is just a forwarder.
     */
    params: Object,
    /**
     * Just like parameters but specifically to filter data.
     */
    filters: Object,
    /**
     * Uses this attribute when sorting items in listing.
     * The prop is just an initial value.
     * Local state is managed by localSortBy.
     */
    sortBy: String,
    /**
     * Ascending or Descending?
     * The prop is just an initial value.
     * Local state is managed by localSortOrder.
     */
    sortOrder: {
      type: String,
      validator(e) {
        return ["asc", "desc"].includes(e);
      }
    },
    /**
     * Default search query to use
     * The prop is just an initial value.
     * Local state is managed by localSearch.
     */
    search: {
      type: String
    },
    /**
     * List of attributes to display in a list
     */
    attrs: {
      type: Array
    },
    /**
     * An adaptor defines which attributes to be passed to layout
     * This is helpful when you don't know which attributes are sent from API
     * Also useful when you need to show all the columns except few.
     */
    attrsAdaptor: {
      type: Function,
      default: (e) => e
    },
    /**
     * Additional request payload while making requests.
     * requestHandler will get this in the context with `payload` key
     */
    requestPayload: {
      default: () => {
      }
    },
    /**
     * Request Handler handles the API requests
     * Use this prop to handle requests individually.
     * If set, will get higher priority over global handler
     */
    requestHandler: {
      type: Function
    },
    /**
     * Version is being used for stateManager
     */
    version: {
      type: [String, Number],
      default: 1
    }
  },
  data() {
    const e = this.getState(), { page: t, perPage: r, sortBy: s, sortOrder: a, search: n, attrSettings: i } = e;
    return {
      /**
       * These local variables are copy of props.
       * This is required as the values given as props are considered as initial values.
       * The component may change these values as user interacts with interface.
       * Thought of updating the props vial .sync modifier but in that case user will have to
       * create a state in host component to sync values.
       */
      localPage: t,
      localPerPage: r,
      localSortBy: s,
      localSortOrder: a,
      localSearch: n,
      attrSettings: i,
      items: null,
      /**
       * serverPage only gets updated after success full response respected to page.
       * This is added to prevent a flash update of indexes due to "page" variable change.
       */
      serverPage: null,
      selection: [],
      error: !1,
      response: null,
      count: 0,
      paginationMode: null,
      isFirstRequest: !0,
      loading: !1,
      loadingMore: !1,
      loadingPage: !1,
      initializingState: !0
    };
  },
  created() {
  },
  /**
   * Once all the child components are ready and provided a proper state like "paginationMode"
   * call initialization of table.
   */
  mounted() {
    this.setDefaultAttrSettings();
    const { filters: e } = this.getState();
    this.$emit("update:filters", e), this.$nextTick(() => {
      this.init(), this.initializingState = !1;
    });
  },
  provide() {
    return {
      setSearch: this.setSearch,
      setSort: this.setSort,
      setPaginationMode: this.setPaginationMode,
      setSelection: this.setSelection,
      setItems: this.setItems,
      setPage: this.setPage,
      setPerPage: this.setPerPage,
      updateAttr: this.updateAttr,
      loadMore: this.loadMore,
      getPaginationMode: this.getPaginationMode
    };
  },
  watch: {
    /**
     * Only filters, params, search, sortBy & sortOrder props will react to change
     * All other props are non-reactive once component is initialized.
     * When filters and params are changed, we need to reset the page
     * and resetting a page will use the latest filter and params props.
     */
    watchFilters: {
      deep: !0,
      handler() {
        this.initializingState || this.setPage(1);
      }
    },
    /**
     * params is just a forwarder & it does not have
     * any usage in the component.
     */
    params: {
      deep: !0,
      handler(e, t) {
        xu(e, t) || this.setPage(1);
      }
    },
    search(e) {
      this.setSearch(e);
    },
    sortBy(e) {
      this.setSort({ by: e, order: this.localSortOrder });
    },
    sortOrder(e) {
      this.setSort({ by: this.localSortOrder, order: e });
    },
    selection: {
      deep: !0,
      handler(e, t) {
        this.$emit("selection", e, t);
      }
    },
    "$route.query.page"(e) {
      e ? this.localPage !== Number(e) && this.setPage(Number(e)) : this.setPage(1);
    }
  },
  computed: {
    /**
     * Why these watch-computed required:
     * https://stackoverflow.com/a/74945916/3165956
     */
    watchFilters() {
      return Object.assign({}, this.filters);
    },
    instance() {
      return this;
    },
    /**
     * When attrs is provided in props, the same attr.name is used to find column value from response.
     * If the attrs is not provided, we can get first item of response and get keys from there as fallback.
     */
    serializedAttrs() {
      var r;
      const e = this.attrs || Object.keys(((r = this.items) == null ? void 0 : r[0]) || {}), t = this.attrsAdaptor(e);
      return this.attrSerializer(t);
    },
    isEmpty() {
      var e;
      return ((e = this.items) == null ? void 0 : e.length) == 0;
    },
    scope() {
      return {
        items: this.items,
        response: this.response,
        loading: this.loading,
        isEmpty: this.isEmpty,
        refresh: this.refresh,
        selection: this.selection,
        instance: this.instance,
        loadingPage: this.loadingPage,
        loadingMore: this.loadingMore
      };
    },
    requestHandlerPayload() {
      return {
        params: this.params,
        filters: this.filters,
        search: this.localSearch,
        page: this.localPage,
        perPage: this.localPerPage,
        sortBy: this.localSortBy,
        sortOrder: this.localSortOrder,
        config: this.config,
        attrSettings: this.attrSettings,
        version: this.version,
        //To be deprecated in future
        pagination: {
          page: this.localPage,
          perPage: this.localPerPage
        },
        //To be deprecated in future
        sort: {
          by: this.localSortBy,
          order: this.localSortOrder
        }
      };
    }
  },
  methods: {
    init() {
      var t, r;
      if (!this.endpoint)
        return;
      this.$vueList.options.stateManager.init(this.endpoint, {
        requestPayload: this.requestPayload,
        version: this.version
      });
      const e = this.localPage || ((r = (t = this.$route) == null ? void 0 : t.query) == null ? void 0 : r.page) || this.page;
      if (e < 1) {
        const s = this.$route.query || {};
        this.$router.replace({
          query: {
            ...s,
            page: void 0
          }
        });
      } else
        this.setPage(e);
    },
    getState() {
      var e, t;
      try {
        const r = this.$vueList.options.stateManager.get(this.endpoint, {
          requestPayload: this.requestPayload,
          version: this.version
        });
        return {
          page: ((e = r == null ? void 0 : r.pagination) == null ? void 0 : e.page) || this.page,
          perPage: ((t = r == null ? void 0 : r.pagination) == null ? void 0 : t.perPage) || this.perPage,
          sortBy: (r == null ? void 0 : r.sort.by) || this.sortBy,
          sortOrder: (r == null ? void 0 : r.sort.order) || this.sortOrder,
          search: (r == null ? void 0 : r.search) || this.search,
          attrSettings: r == null ? void 0 : r.attrSettings,
          filters: r == null ? void 0 : r.filters
        };
      } catch (r) {
        return console.error(r), {};
      }
    },
    /**
     * Attribute serializer builds an array of objects with following keys:
     * label, name.
     *
     * input: ['name','email']
     * output: [{label:'Name',name:'name'},{label:'Email',name:'email'} ]
     */
    attrSerializer(e) {
      return e.map((t) => typeof t == "string" ? {
        label: bt(t),
        name: t
      } : (t.attrs && (t.attrs = this.attrSerializer(t.attrs)), {
        label: bt(t.name),
        ...t
      }));
    },
    setSearch(e) {
      this.localSearch = e, this.setPage(1);
    },
    setSort({ by: e, order: t }) {
      this.localSortBy = e, this.localSortOrder = t, this.setPage(1);
    },
    setPaginationMode(e) {
      this.paginationMode = e;
    },
    getPaginationMode() {
      return this.paginationMode;
    },
    setSelection(e) {
      this.selection = e;
    },
    setItems(e) {
      this.items = e;
    },
    refresh(e) {
      this.paginationMode == "infinite" ? this.setPage(1, e) : this.getData(e);
    },
    setPage(e, t) {
      this.localPage = e, this.getData(t);
    },
    setPerPage(e) {
      this.localPerPage = e, this.setPage(1);
    },
    loadMore() {
      const e = this.localPage;
      this.localPage++;
      const t = this.localPage;
      this.$emit("beforeLoadMore", {
        oldPage: e,
        newPage: t
      }), this.getData();
    },
    setData(e) {
      this.paginationMode == "infinite" ? (this.localPage == 1 ? this.items = e.items : this.items = (this.items || []).concat(e.items), this.$emit("afterLoadMore", e)) : (this.items = e.items, this.$emit("afterLoad", e)), this.count = e.count;
    },
    /**
     * Updates the query parameters in the router when pagination is available.
     *
     * Initially when the component is loaded, the default page is 1 and no query param is added.
     * So when navigating back to page=1, we should avoid adding page = 1 in query param to avoid
     * additional history in routing.
     */
    setUrl() {
      if (this.$router && this.paginationMode == "paging" && this.$route.query.page != this.localPage) {
        const e = this.$route.query || {};
        this.$router.push({
          query: {
            ...e,
            page: this.localPage
          }
        });
      }
    },
    getData(e = {}) {
      this.error = !1, this.setLoader(!0), (this.requestHandler || this.$vueList.options.requestHandler)({
        method: "get",
        endpoint: this.endpoint,
        payload: {
          ...this.requestPayload,
          ...e
        },
        ...this.requestHandlerPayload
      }).then((r) => {
        this.response = r, this.setStateOnStateManager(), this.selection = [], this.$emit("res", r), this.setData(r), this.setUrl(), this.setLoader(!1), this.serverPage = this.localPage;
      }).catch((r) => {
        throw this.error = r, this.setLoader(!1), new Error(r);
      });
    },
    setLoader(e) {
      e ? this.paginationMode == "infinite" ? this.loadingMore = !0 : this.isFirstRequest ? this.loading = !0 : this.loadingPage = !0 : (this.isFirstRequest = !1, this.loading = !1, this.loadingPage = !1, this.loadingMore = !1);
    },
    /**
     * Update the config of an attribute
     *
     * @param {name} string Name of an attribute
     * @param {prop} string A property to update
     * @param {value} string A value to set
     */
    updateAttr(e, t, r) {
      this.attrSettings[e] || (this.attrSettings[e] = {}), this.attrSettings[e][t] = r, this.setStateOnStateManager();
    },
    setDefaultAttrSettings() {
      if (this.attrSettings)
        return;
      const e = this.serializedAttrs.reduce((t, r) => (t[r.name] = {
        visible: !0
      }, t), {});
      this.attrSettings = e;
    },
    setStateOnStateManager() {
      const e = { ...this.requestHandlerPayload };
      this.paginationMode === "infinite" && (e.page = 1, e.pagination.page = 1), this.$vueList.options.stateManager.set(this.endpoint, e);
    },
    clearState() {
      this.$vueList.options.stateManager.set(this.endpoint);
    }
  }
}, Cu = { class: "v-list" }, ju = /* @__PURE__ */ b("p", null, "Loading...", -1), Mu = /* @__PURE__ */ b("p", null, "Loading More...", -1), Lu = /* @__PURE__ */ b("p", null, "Loading Page...", -1), Eu = /* @__PURE__ */ b("p", null, "There was an error while processing your request.", -1), Iu = /* @__PURE__ */ b("p", null, "No data found!", -1);
function Ru(e, t, r, s, a, n) {
  return f(), d("div", Cu, [
    c(e.$slots, "header", A(ee(n.scope))),
    a.loading ? c(e.$slots, "loading", A(O({ key: 0 }, n.scope)), () => [
      ju
    ]) : (f(), d(j, { key: 1 }, [
      a.loadingMore ? c(e.$slots, "loading-more", A(O({ key: 0 }, n.scope)), () => [
        Mu
      ]) : le("", !0),
      a.loadingPage ? c(e.$slots, "loading-page", A(O({ key: 1 }, n.scope)), () => [
        Lu
      ]) : le("", !0),
      a.error ? c(e.$slots, "error", O({
        key: 2,
        error: a.error
      }, n.scope), () => [
        b("div", null, [
          Eu,
          b("p", null, x(a.error), 1)
        ])
      ]) : n.isEmpty ? c(e.$slots, "empty", A(O({ key: 3 }, n.scope)), () => [
        Iu
      ]) : c(e.$slots, "default", A(O({ key: 4 }, n.scope)))
    ], 64)),
    c(e.$slots, "footer", A(ee(n.scope)))
  ]);
}
const Du = /* @__PURE__ */ L(wu, [["render", Ru]]), F = {
  props: {
    parent: Object
  },
  computed: {
    root() {
      return this.parent || this.$parent;
    }
  }
}, Nu = {
  mixins: [F],
  props: {
    /**
     * Number of buttons to display in pagination.
     * Current Page will be center and other pages will be added in start and end.
     * Odd number is recommended
     */
    pageLinks: {
      type: Number,
      default: 5
    }
  },
  inject: ["setPaginationMode", "setPage"],
  created() {
    this.setPaginationMode("paging");
  },
  computed: {
    page() {
      return this.root.localPage;
    },
    perPage() {
      return this.root.localPerPage;
    },
    count() {
      return this.root.count;
    },
    total() {
      return Math.ceil(this.count / this.perPage);
    },
    halfWay() {
      return Math.floor(this.pageLinks / 2);
    },
    pagesToDisplay() {
      const e = Array.apply(
        null,
        Array(Math.min(this.pageLinks, this.total))
      );
      return this.page <= this.halfWay ? e.map((t, r) => r + 1) : this.total - this.page < this.halfWay ? e.map((t, r) => this.total - r).reverse() : e.map((t, r) => this.page - this.halfWay + r);
    },
    hasNext() {
      return this.page * this.perPage < this.count;
    },
    hasPrev() {
      return this.page != 1;
    }
  },
  methods: {
    prev() {
      this.setPage(this.page - 1);
    },
    next() {
      this.setPage(this.page + 1);
    },
    first() {
      this.setPage(1);
    },
    last() {
      this.setPage(this.total);
    }
  }
}, Uu = { class: "v-list-pagination" }, Bu = ["disabled"], Fu = ["disabled"], ku = ["onClick"], zu = ["disabled"], Hu = ["disabled"];
function Gu(e, t, r, s, a, n) {
  return f(), d("div", Uu, [
    c(e.$slots, "first", {
      first: n.first,
      hasPrev: n.hasPrev
    }, () => [
      b("button", {
        disabled: !n.hasPrev,
        onClick: t[0] || (t[0] = (...i) => n.first && n.first(...i))
      }, "First", 8, Bu)
    ]),
    c(e.$slots, "prev", {
      prev: n.prev,
      hasPrev: n.hasPrev
    }, () => [
      b("button", {
        disabled: !n.hasPrev,
        onClick: t[1] || (t[1] = (...i) => n.prev && n.prev(...i))
      }, "Prev", 8, Fu)
    ]),
    (f(!0), d(j, null, N(n.pagesToDisplay, (i) => c(e.$slots, "page", {
      change: n.setPage,
      value: i,
      isActive: i == n.page
    }, () => [
      i == n.page ? (f(), d("span", {
        key: `page-${i}`
      }, x(i), 1)) : (f(), d("button", {
        key: `page-${i}`,
        onClick: (o) => n.setPage(i)
      }, x(i), 9, ku))
    ])), 256)),
    c(e.$slots, "next", {
      next: n.next,
      hasNext: n.hasNext
    }, () => [
      b("button", {
        disabled: !n.hasNext,
        onClick: t[2] || (t[2] = (...i) => n.next && n.next(...i))
      }, "Next", 8, zu)
    ]),
    c(e.$slots, "last", {
      last: n.last,
      hasNext: n.hasNext
    }, () => [
      b("button", {
        disabled: !n.hasNext,
        onClick: t[3] || (t[3] = (...i) => n.last && n.last(...i))
      }, "Last", 8, Hu)
    ])
  ]);
}
const qu = /* @__PURE__ */ L(Nu, [["render", Gu]]), Wu = {
  mixins: [F],
  computed: {
    items() {
      return this.root.items || [];
    },
    showing() {
      return this.items.length;
    },
    count() {
      return this.root.count;
    }
  }
}, Vu = { class: "v-list-counter" };
function Zu(e, t, r, s, a, n) {
  return f(), d("div", Vu, [
    c(e.$slots, "default", {
      showing: n.showing,
      count: n.count
    }, () => [
      b("span", null, " Showing " + x(n.showing) + " items out of " + x(n.count), 1)
    ])
  ]);
}
const Ku = /* @__PURE__ */ L(Wu, [["render", Zu]]), Ju = {
  mixins: [F],
  inject: ["setPerPage"],
  props: {
    /**
     * An array of options which lets user select how many items they want to see in a list at a time.
     * Provide an object with 'label' and 'value' keys to have a label different then a value.
     */
    options: {
      type: Array,
      default: () => [10, 25, 50, 100]
    }
  },
  computed: {
    perPage() {
      return this.root.localPerPage;
    },
    serializedOptions() {
      return this.options.map((e) => typeof e != "object" ? {
        value: e,
        label: e
      } : e);
    }
  }
}, Yu = { class: "v-list-per-page" }, Xu = ["value"], Qu = ["value"];
function el(e, t, r, s, a, n) {
  return f(), d("div", Yu, [
    c(e.$slots, "default", {
      value: n.perPage,
      change: n.setPerPage,
      options: n.serializedOptions
    }, () => [
      b("select", {
        value: n.perPage,
        onInput: t[0] || (t[0] = (i) => n.setPerPage(i.target.value))
      }, [
        (f(!0), d(j, null, N(n.serializedOptions, (i, o) => (f(), d("option", {
          key: `option-${o}`,
          value: i.value
        }, x(i.label), 9, Qu))), 128))
      ], 40, Xu)
    ])
  ]);
}
const tl = /* @__PURE__ */ L(Ju, [["render", el]]), rl = {
  mixins: [F],
  inject: ["updateAttr"]
}, nl = { class: "v-list-attributes" }, sl = ["checked", "onChange"];
function al(e, t, r, s, a, n) {
  return f(), d("div", nl, [
    (f(!0), d(j, null, N(e.root.serializedAttrs, (i, o) => c(e.$slots, "default", {
      update: n.updateAttr,
      attr: i
    }, () => {
      var l, u;
      return [
        (f(), d("label", {
          key: `attr-${o}`
        }, [
          b("span", null, x(i.label), 1),
          b("input", {
            type: "checkbox",
            checked: (u = (l = e.root.attrSettings) == null ? void 0 : l[i.name]) == null ? void 0 : u.visible,
            onChange: (v) => n.updateAttr(i.name, "visible", v.target.checked)
          }, null, 40, sl)
        ]))
      ];
    })), 256))
  ]);
}
const il = /* @__PURE__ */ L(rl, [["render", al]]), ol = {
  mixins: [F],
  inject: ["setSearch"],
  props: {
    /**
     * Wait till this time to send an API request to avoid multiple requests when user is typing.
     */
    debounceTime: {
      type: Number,
      default: 1e3
    }
  },
  data() {
    return {
      debounce: yt,
      set: null
    };
  },
  created() {
    this.set = yt((e) => {
      this.setSearch(e);
    }, this.debounceTime);
  }
}, ul = { class: "v-list-search" }, ll = ["value"];
function cl(e, t, r, s, a, n) {
  return f(), d("div", ul, [
    c(e.$slots, "default", {
      value: e.root.localSearch,
      set: a.set
    }, () => [
      b("input", {
        type: "text",
        value: e.root.localSearch,
        onInput: t[0] || (t[0] = (i) => a.set(i.target.value)),
        placeholder: "Search"
      }, null, 40, ll)
    ])
  ]);
}
const fl = /* @__PURE__ */ L(ol, [["render", cl]]), dl = {
  mixins: [F],
  inject: ["setPaginationMode", "loadMore"],
  created() {
    this.setPaginationMode("infinite");
  },
  computed: {
    loadingMore() {
      return this.root.loadingMore;
    },
    loaded() {
      var e;
      return (e = this.root.items) == null ? void 0 : e.length;
    },
    count() {
      return this.root.count;
    }
  }
}, hl = { class: "v-list-load-more" }, gl = /* @__PURE__ */ b("p", null, "— That's all —", -1);
function pl(e, t, r, s, a, n) {
  return f(), d("div", hl, [
    n.count > n.loaded ? c(e.$slots, "default", {
      key: 0,
      loading: n.loadingMore,
      loadMore: n.loadMore
    }, () => [
      b("button", {
        onClick: t[0] || (t[0] = (...i) => n.loadMore && n.loadMore(...i))
      }, "Load More")
    ]) : c(e.$slots, "end", { key: 1 }, () => [
      gl
    ])
  ]);
}
const yl = /* @__PURE__ */ L(dl, [["render", pl]]), bl = {
  mixins: [F],
  inject: ["setPage"],
  computed: {
    options() {
      const e = [];
      for (var t = 1; t <= this.total; t++)
        e.push(t);
      return e;
    },
    page() {
      return this.root.localPage;
    },
    perPage() {
      return this.root.localPerPage;
    },
    count() {
      return this.root.count;
    },
    total() {
      return Math.ceil(this.count / this.perPage);
    }
  }
}, vl = { class: "v-list-go-to" }, ml = ["value"];
function _l(e, t, r, s, a, n) {
  return f(), d("div", vl, [
    c(e.$slots, "select", {
      change: n.setPage,
      value: n.page,
      options: n.options,
      total: n.total
    }, () => [
      b("select", {
        onInput: t[0] || (t[0] = (i) => n.setPage(i.target.value)),
        value: n.page
      }, [
        (f(!0), d(j, null, N(n.options, (i, o) => (f(), d("option", {
          key: `option-${o}`
        }, x(i), 1))), 128))
      ], 40, ml)
    ])
  ]);
}
const $l = /* @__PURE__ */ L(bl, [["render", _l]]), Pl = {
  mixins: [F],
  inject: ["setSort", "getPaginationMode"],
  computed: {
    items() {
      return this.root.items || [];
    },
    attrs() {
      return this.root.serializedAttrs;
    },
    attrSettings() {
      return this.root.attrSettings;
    },
    pagination() {
      return this.root.paginationConfig;
    },
    sortBy() {
      return this.root.localSortBy;
    },
    sortOrder() {
      return this.root.localSortOrder;
    }
  },
  methods: {
    sortItemsBy(e) {
      let t;
      this.sortOrder == "asc" ? t = "desc" : t = "asc", this.setSort({ by: e.name, order: t });
    },
    itemIndex(e) {
      return this.getPaginationMode() ? e + 1 : this.root.localPerPage * (this.root.serverPage - 1) + e + 1;
    }
  }
}, dr = (...e) => e.join("-"), Sl = {
  inject: ["reorder"],
  props: {
    modelValue: {
      type: Array,
      default: () => []
    },
    isSelected: {
      type: Function,
      default: () => null
    },
    rowClass: {
      type: Function,
      default: () => null
    }
  },
  computed: {
    value: {
      get() {
        return this.modelValue;
      },
      set(e) {
        this.$emit("update:modelValue", e);
      }
    }
  },
  data() {
    return {
      key: dr
    };
  }
}, Tl = { key: 1 };
function Al(e, t, r, s, a, n) {
  const i = vt("Draggable");
  return n.reorder ? (f(), mt(i, {
    key: 0,
    handle: ".v-list-table__drag",
    modelValue: n.value,
    "onUpdate:modelValue": t[0] || (t[0] = (o) => n.value = o),
    "item-key": "name",
    tag: "tbody"
  }, {
    header: Z(() => [
      c(e.$slots, "body-start")
    ]),
    item: Z(({ element: o, index: l }) => [
      b("tr", {
        class: te([
          { "v-list-table__selected": r.isSelected(o) },
          r.rowClass ? r.rowClass(o, l) : ""
        ])
      }, [
        c(e.$slots, "body-row", {
          row: o,
          rowIndex: l
        })
      ], 2)
    ]),
    footer: Z(() => [
      c(e.$slots, "body-end")
    ]),
    _: 3
  }, 8, ["modelValue"])) : (f(), d("tbody", Tl, [
    c(e.$slots, "body-start"),
    (f(!0), d(j, null, N(r.modelValue, (o, l) => (f(), d("tr", {
      key: a.key("body-row", l),
      class: te([
        { "v-list-table__selected": r.isSelected(o) },
        r.rowClass ? r.rowClass(o, l) : ""
      ])
    }, [
      c(e.$slots, "body-row", {
        row: o,
        rowIndex: l
      })
    ], 2))), 128)),
    c(e.$slots, "body-end")
  ]));
}
const xl = /* @__PURE__ */ L(Sl, [["render", Al]]), Ol = {
  components: {
    TheTbody: xl
  },
  mixins: [Pl],
  props: {
    reorder: {
      type: Boolean,
      default: !1
    },
    rowClass: {
      type: Function
    }
  },
  provide() {
    return {
      reorder: this.reorder
    };
  },
  inject: ["setSelection", "setItems"],
  data() {
    return {
      key: dr,
      headers: [],
      body: []
    };
  },
  watch: {
    attrSettings: {
      deep: !0,
      handler(e) {
        this.headers = [], this.body = [], this.generateHeader(this.attrs, e, 0);
      }
    }
  },
  created() {
    this.generateHeader(this.attrs, this.attrSettings, 0);
  },
  computed: {
    rows: {
      set(e) {
        this.$emit("reorder", e), this.setItems(e);
      },
      get() {
        return qo(this.items);
      }
    },
    selectionState() {
      return this.root.selection.length === this.rows.length ? "all" : this.root.selection.length === 0 ? "none" : "some";
    }
  },
  methods: {
    rowspan(e, t) {
      let r = 1;
      for (var s = e + 1; s < this.headers.length; s++) {
        if (this.headers[s].some((i) => i.key.startsWith(t)))
          return r;
        r++;
      }
      return r;
    },
    colspan(e, t) {
      let r = 1;
      for (var s = e + 1; s < this.headers.length; s++) {
        const n = this.headers[s].filter((i) => i.key.startsWith(t));
        (n == null ? void 0 : n.length) > 0 && (r = r + n.length - 1);
      }
      return r;
    },
    generateHeader(e, t, r, s = "0") {
      this.headers[r] || (this.headers[r] = []), e.forEach((a, n) => {
        var i;
        if ((i = t == null ? void 0 : t[a.name]) != null && i.visible) {
          const o = s + "" + n;
          if (a.key = o, this.headers[r].push(a), a.attrs) {
            const l = r + 1;
            this.generateHeader(a.attrs, l, o);
          } else
            this.body.push(a);
        }
      });
    },
    columnClass(e) {
      const t = [];
      return e.fix && t.push("v-list-table__fix"), e.type && t.push(`v-list-table__${e.type}`), e.classList && t.push(...e.classList), t;
    },
    thClass(e) {
      const t = [
        ...this.columnClass(e),
        `v-list-table__${e.name}`
      ];
      return e.name == this.sortBy && t.push("v-list-table__sort"), e.sortable && t.push("v-list-table__sortable"), t;
    },
    thStyle(e) {
      const t = {};
      return e.width && (t.width = e.width), t;
    },
    tdClick(e, t) {
      e.onClick ? e.onClick(t) : e.rowClick !== !1 && this.$emit("rowClick", t);
    },
    tdClass(e) {
      const t = [...this.columnClass(e)];
      return this.$attrs.rowClick && e.rowClick !== !1 && t.push("v-list-table__click"), t;
    },
    tdScope(e, t, r) {
      return {
        toggleSelect: () => this.toggleSelect(t),
        isSelected: this.isSelected(t),
        item: t,
        rowIndex: this.itemIndex(r),
        content: this.td(e, t)
      };
    },
    thScope(e) {
      return {
        attr: e,
        toggleSelectAll: () => this.toggleSelectAll(),
        sortBy: this.sortBy,
        sortOrder: this.sortOrder,
        selectionState: this.selectionState
      };
    },
    td(e, t) {
      const r = e.name;
      if (e.valueMap) {
        const s = t[r];
        if (s && e.valueMap[s])
          return e.valueMap[s];
      }
      return e.type && this.$vueList.options.typeAdapters[e.type] ? this.$vueList.options.typeAdapters[e.type](t[r], t) : e.value ? e.value(t) : t[r];
    },
    toggleSelect(e) {
      const t = [...this.root.selection], r = t.findIndex((s) => s.id === e.id);
      r > -1 ? this.$delete(t, r) : t.push({ ...e }), this.setSelection(t);
    },
    isSelected(e) {
      return [...this.root.selection].findIndex((s) => s.id === e.id) > -1;
    },
    toggleSelectAll() {
      switch (this.selectionState) {
        case "all":
          this.setSelection([]);
          break;
        case "some":
        case "none":
          this.setSelection(this.rows);
          break;
      }
    }
  }
}, wl = { class: "v-list-table" }, Cl = ["rowspan", "colspan", "onClick"], jl = { class: "v-list-table__head" }, Ml = { key: 0 }, Ll = { key: 1 }, El = ["onClick"], Il = /* @__PURE__ */ b("span", { class: "v-list-table__drag" }, "Drag", -1);
function Rl(e, t, r, s, a, n) {
  const i = vt("TheTbody");
  return f(), d("table", wl, [
    b("thead", null, [
      (f(!0), d(j, null, N(a.headers, (o, l) => (f(), d("tr", {
        key: a.key("head-row", l),
        class: te(r.rowClass ? r.rowClass(o, l) : "")
      }, [
        (f(!0), d(j, null, N(o, (u, v) => (f(), d("th", {
          key: a.key("head-col", l, v),
          class: te(n.thClass(u)),
          style: hr(n.thStyle(u)),
          rowspan: n.rowspan(l, u.key),
          colspan: n.colspan(l, u.key),
          onClick: (h) => u.sortable ? e.sortItemsBy(u) : null
        }, [
          b("div", jl, [
            c(e.$slots, "th_before", A(ee(n.thScope(u)))),
            c(e.$slots, `th_${u.name}`, A(ee(n.thScope(u))), () => [
              b("span", null, x(u.label), 1)
            ]),
            c(e.$slots, "th_after", A(ee(n.thScope(u))), () => [
              u.name == e.sortBy ? (f(), d(j, { key: 0 }, [
                e.sortOrder == "asc" ? (f(), d("span", Ml, "↑")) : e.sortOrder == "desc" ? (f(), d("span", Ll, "↓")) : le("", !0)
              ], 64)) : le("", !0)
            ])
          ])
        ], 14, Cl))), 128))
      ], 2))), 128))
    ]),
    gr(i, {
      reorder: r.reorder,
      modelValue: n.rows,
      "onUpdate:modelValue": t[0] || (t[0] = (o) => n.rows = o),
      "is-selected": n.isSelected,
      "row-class": r.rowClass
    }, {
      "body-start": Z(() => [
        c(e.$slots, "body-start")
      ]),
      "body-row": Z(({ row: o, rowIndex: l }) => [
        (f(!0), d(j, null, N(a.body, (u, v) => (f(), d("td", {
          key: a.key("body-col", v),
          class: te(n.tdClass(u)),
          onClick: (h) => n.tdClick(u, o)
        }, [
          e.$slots[u.name] ? c(e.$slots, u.name, A(O({ key: 0 }, n.tdScope(u, o, l))), () => [
            ye(x(o[u.name]), 1)
          ]) : e.$vueList.options.slots && e.$vueList.options.slots[u.name] ? (f(), mt(pr(e.$vueList.options.slots[u.name]), A(O({ key: 1 }, n.tdScope(u, o, l))), null, 16)) : u.name == "_index" ? c(e.$slots, "_index", A(O({ key: 2 }, n.tdScope(u, o, l))), () => [
            ye(x(e.itemIndex(l)), 1)
          ]) : u.name == "_drag" ? c(e.$slots, "_drag", A(O({ key: 3 }, n.tdScope(u, o, l))), () => [
            Il
          ]) : c(e.$slots, u.name, A(O({ key: 4 }, n.tdScope(u, o, l))), () => [
            ye(x(n.td(u, o)), 1)
          ])
        ], 10, El))), 128))
      ]),
      "body-end": Z(() => [
        c(e.$slots, "body-end")
      ]),
      _: 3
    }, 8, ["reorder", "modelValue", "is-selected", "row-class"])
  ]);
}
const Dl = /* @__PURE__ */ L(Ol, [["render", Rl]]), Nl = (e, t = {}) => {
  const r = Object.assign({}, yr, t), s = r.componentPrefix;
  e.config.globalProperties.$vueList = { options: r }, e.component(`${s}List`, Du), e.component(`${s}ListPagination`, qu), e.component(`${s}ListCounter`, Ku), e.component(`${s}ListPerPage`, tl), e.component(`${s}ListAttributes`, il), e.component(`${s}ListSearch`, fl), e.component(`${s}ListLoadMore`, yl), e.component(`${s}ListTable`, Dl), e.component(`${s}ListGoTo`, $l);
}, Ul = {
  install: Nl
};
typeof window < "u" && window.Vue && window.Vue.use(Ul);
export {
  Ul as default
};
